export const PinIcon = ({ ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' fill='none' {...rest}>
    <path
      fillRule='evenodd'
      d='M7.75 2.5a.75.75 0 1 0 0 1.5h.747v8.882l-2.281 2.336c-.467.478-.128 1.282.541 1.282h4.493v5.25a.75.75 0 1 0 1.5 0V16.5h4.493c.669 0 1.008-.804.541-1.282l-2.281-2.336V4h.747a.75.75 0 1 0 0-1.5h-8.5zM14.002 4H9.998v9.493L8.526 15h6.947l-1.472-1.507V4z'
      fill='currentColor'
    />
  </svg>
);

export const FilledPinIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'>
    <path
      d='M7.75 2a.75.75 0 1 0 0 1.5h.747v8.882l-2.281 2.336c-.467.478-.128 1.282.541 1.282h4.493v5.25a.75.75 0 1 0 1.5 0V16h4.493c.669 0 1.008-.804.541-1.282l-2.281-2.336V3.5h.747a.75.75 0 1 0 0-1.5h-8.5z'
      fill='currentColor'
    />
  </svg>
);

export const AddIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' fill='#00000'>
    <path fillRule='evenodd' d='M12 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 1 1 7 0zm-1.5 0a2 2 0 1 1-4 0 2 2 0 1 1 4 0z' />
    <path d='M3.5 15.5a2 2 0 0 1 2-2h6a2 2 0 0 1 1.842 1.218 6.03 6.03 0 0 1 1.129-1.071A3.5 3.5 0 0 0 11.5 12h-6A3.5 3.5 0 0 0 2 15.5v4.25a.75.75 0 0 0 .75.75h9.591c-.168-.475-.278-.978-.321-1.5H3.5v-3.5zm14.5-1a.75.75 0 0 0-.75.75v2.5h-2.5a.75.75 0 1 0 0 1.5h2.5v2.5a.75.75 0 1 0 1.5 0v-2.5h2.5a.75.75 0 1 0 0-1.5h-2.5v-2.5a.75.75 0 0 0-.75-.75z' />
  </svg>
);

export const FilterIcon = ({ fill = '#000000', ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' {...rest}>
    <path
      d='M16.395 1.811H1.605c-.492 0-.8.536-.552.964l4.673 7.943v4.834a.64.64 0 0 0 .639.643h5.271a.64.64 0 0 0 .639-.643v-4.834l4.675-7.943c.245-.428-.062-.964-.554-.964zm-5.559 12.937H7.164v-3.134h3.674v3.134h-.002zm.193-4.753l-.191.333H7.162l-.191-.333-3.984-6.738h12.025l-3.984 6.738z'
      fill={fill}
    />
  </svg>
);

export const ArrowIcon = ({ fill = '#000000', ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' {...rest}>
    <path
      d='M12.469 6.271h-1.266c-.072 0-.141.031-.189.086l-3.42 3.942V1.501c0-.069-.056-.125-.125-.125h-.937c-.069 0-.125.056-.125.125v8.798l-3.42-3.942c-.047-.055-.116-.086-.189-.086H1.531c-.106 0-.164.127-.094.206l5.186 5.977a.5.5 0 0 0 .377.172.5.5 0 0 0 .377-.172l5.184-5.977c.07-.081.012-.206-.094-.206z'
      fill={fill}
    />
  </svg>
);

export const BrazilIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'>
    <path
      d='M2 5.25A1.25 1.25 0 0 1 3.25 4h17.5A1.25 1.25 0 0 1 22 5.25v13.5A1.25 1.25 0 0 1 20.75 20H3.25A1.25 1.25 0 0 1 2 18.75V5.25z'
      fill='#009c3b'
    />
    <path d='M12 5.5L20.5 12L12 18.5L3.5 12L12 5.5Z' fill='#ffdf00' />
    <circle cx='12' cy='12' r='3.625' fill='#002776' />
    <path
      d='M15.444 13.134A3.62 3.62 0 0 0 15.625 12c0-.162-.011-.321-.031-.477A14.94 14.94 0 0 0 9 10h-.024c-.295.445-.494.959-.569 1.513L9 11.5a13.44 13.44 0 0 1 6.444 1.634z'
      fill='#fff'
    />
  </svg>
);

export const ClockHistoryOutlined = ({ color }) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.7724 1.52844C12.516 1.50953 12.2584 1.5 12 1.5V0C12.2953 0 12.5897 0.010893 12.8828 0.0325082L12.7724 1.52844ZM15.7789 2.20357C15.2978 2.018 14.8037 1.86811 14.3006 1.75512L14.6292 0.291573C15.2042 0.420694 15.7689 0.591998 16.3187 0.804082L15.7789 2.20357ZM17.8335 3.26957C17.6187 3.12603 17.3991 2.99081 17.1754 2.86408L17.9148 1.55895C18.1705 1.7038 18.4213 1.85832 18.6668 2.02236C18.9124 2.18641 19.1511 2.35905 19.3828 2.53984L18.4599 3.72236C18.2572 3.56418 18.0483 3.41311 17.8335 3.26957ZM20.5847 5.95402C20.2877 5.53243 19.9602 5.13328 19.6046 4.75982L20.691 3.72552C21.0973 4.15232 21.4717 4.60849 21.811 5.0903L20.5847 5.95402ZM21.7007 7.98182C21.6019 7.74312 21.4945 7.50874 21.3789 7.27907L22.7187 6.60466C22.8508 6.86715 22.9736 7.13501 23.0866 7.4078C23.1996 7.68059 23.3022 7.95679 23.3943 8.23581L21.9701 8.70635C21.8894 8.46221 21.7996 8.22053 21.7007 7.98182ZM22.4968 11.7423C22.4842 11.2268 22.4336 10.713 22.3454 10.2049L23.8233 9.94846C23.9241 10.5291 23.9819 11.1164 23.9964 11.7055L22.4968 11.7423ZM22.2983 14.0484C22.3487 13.795 22.3896 13.5405 22.421 13.2853L23.9098 13.4689C23.8738 13.7606 23.827 14.0515 23.7694 14.3411C23.7118 14.6307 23.6437 14.9173 23.5653 15.2006L22.1197 14.8005C22.1882 14.5527 22.2478 14.3019 22.2983 14.0484ZM20.871 17.6175C21.1468 17.1818 21.3902 16.7264 21.5992 16.255L22.9705 16.8629C22.7317 17.4016 22.4535 17.9221 22.1383 18.42L20.871 17.6175ZM19.4246 19.4246C19.6073 19.2419 19.7828 19.053 19.9507 18.8583L21.0865 19.8381C20.8946 20.0606 20.6941 20.2765 20.4853 20.4853L19.4246 19.4246Z'
      fill={color}
    />
    <path
      d='M12 1.5C10.2733 1.5 8.57318 1.92585 7.05034 2.73983C5.52749 3.5538 4.2289 4.73078 3.26957 6.16651C2.31025 7.60224 1.71981 9.2524 1.55056 10.9708C1.38131 12.6892 1.63848 14.4229 2.29927 16.0182C2.96006 17.6135 4.00409 19.0212 5.33887 20.1166C6.67366 21.212 8.258 21.9614 9.95156 22.2982C11.6451 22.6351 13.3956 22.5491 15.048 22.0479C16.7004 21.5466 18.2036 20.6456 19.4246 19.4246L20.4853 20.4853C19.0899 21.8807 17.3719 22.9104 15.4834 23.4833C13.595 24.0561 11.5944 24.1544 9.65892 23.7694C7.72343 23.3844 5.91275 22.528 4.38728 21.2761C2.86182 20.0242 1.66864 18.4154 0.913449 16.5922C0.158257 14.769 -0.135642 12.7877 0.0577863 10.8238C0.251215 8.85988 0.925999 6.97399 2.02237 5.33316C3.11874 3.69233 4.60285 2.3472 6.34324 1.41694C8.08364 0.486685 10.0266 0 12 0V1.5Z'
      fill={color}
    />
    <path
      d='M11.25 4.5C11.6642 4.5 12 4.83579 12 5.25V13.0648L16.8721 15.8488C17.2317 16.0543 17.3567 16.5125 17.1512 16.8721C16.9457 17.2317 16.4875 17.3567 16.1279 17.1512L10.8779 14.1512C10.6442 14.0177 10.5 13.7691 10.5 13.5V5.25C10.5 4.83579 10.8358 4.5 11.25 4.5Z'
      fill={color}
    />
  </svg>
);

export const LoadingOutlined = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path d='M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
      <path d='M3 3v5h5' />
      <path d='M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16' />
      <path d='M16 16h5v5' />
    </svg>
  );
};

export const TicketOutlined = () => {
  return (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7 9.625C7 9.14175 7.39175 8.75 7.875 8.75H20.125C20.6082 8.75 21 9.14175 21 9.625C21 10.1082 20.6082 10.5 20.125 10.5H7.875C7.39175 10.5 7 10.1082 7 9.625Z'
        fill='black'
        fillOpacity='0.85'
      />
      <path
        d='M7 18.375C7 17.8918 7.39175 17.5 7.875 17.5H20.125C20.6082 17.5 21 17.8918 21 18.375C21 18.8582 20.6082 19.25 20.125 19.25H7.875C7.39175 19.25 7 18.8582 7 18.375Z'
        fill='black'
        fillOpacity='0.85'
      />
      <path
        d='M8.75 12.25C7.7835 12.25 7 13.0335 7 14C7 14.9665 7.7835 15.75 8.75 15.75H19.25C20.2165 15.75 21 14.9665 21 14C21 13.0335 20.2165 12.25 19.25 12.25H8.75Z'
        fill='black'
        fillOpacity='0.85'
      />
      <path
        d='M0 7.875C0 6.42525 1.17525 5.25 2.625 5.25H25.375C26.8247 5.25 28 6.42525 28 7.875V10.5C28 10.9832 27.6082 11.375 27.125 11.375C25.6753 11.375 24.5 12.5503 24.5 14C24.5 15.4497 25.6753 16.625 27.125 16.625C27.6082 16.625 28 17.0168 28 17.5V20.125C28 21.5747 26.8247 22.75 25.375 22.75H2.625C1.17525 22.75 0 21.5747 0 20.125V17.5C0 17.0168 0.391751 16.625 0.875 16.625C2.32475 16.625 3.5 15.4497 3.5 14C3.5 12.5503 2.32475 11.375 0.875 11.375C0.391751 11.375 0 10.9832 0 10.5V7.875ZM2.625 7C2.14175 7 1.75 7.39175 1.75 7.875V9.71252C3.74696 10.1179 5.25 11.8834 5.25 14C5.25 16.1166 3.74696 17.8821 1.75 18.2875V20.125C1.75 20.6082 2.14175 21 2.625 21H25.375C25.8582 21 26.25 20.6082 26.25 20.125V18.2875C24.253 17.8821 22.75 16.1166 22.75 14C22.75 11.8834 24.253 10.1179 26.25 9.71252V7.875C26.25 7.39175 25.8582 7 25.375 7H2.625Z'
        fill='black'
        fillOpacity='0.85'
      />
    </svg>
  );
};

export const BlinketSmallLogo = () => {
  return (
    <svg width='34' height='32' viewBox='0 0 34 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.7097 32C25.5628 32 32.7397 24.8366 32.7397 16C32.7397 7.16344 25.5628 0 16.7097 0C7.85656 0 0.679688 7.16344 0.679688 16C0.679688 24.8366 7.85656 32 16.7097 32Z'
        fill='#FFBC00'
      />
      <path
        d='M34 11.8876V7.41602H0V11.9176C0.09 11.9176 0.17 11.8876 0.25 11.8876C2.45 11.8876 4.24 13.7242 4.24 15.9999C4.24 18.2757 2.46 20.1122 0.25 20.1122C0.16 20.1122 0.08 20.0922 0 20.0823V24.5838H34V20.1122C31.8 20.1122 30.01 18.2757 30.01 15.9999C30.01 13.7242 31.79 11.8876 34 11.8876Z'
        fill='#0D2772'
      />
      <path d='M7.63996 8.3042H6.45996V10.8594H7.63996V8.3042Z' fill='white' />
      <path d='M7.63996 12.377H6.45996V14.9322H7.63996V12.377Z' fill='white' />
      <path d='M7.63996 16.7983H6.45996V19.3535H7.63996V16.7983Z' fill='white' />
      <path d='M7.63996 21.1704H6.45996V23.7256H7.63996V21.1704Z' fill='white' />
      <path d='M28.1097 8.3042H26.9297V10.8594H28.1097V8.3042Z' fill='white' />
      <path d='M28.1097 12.377H26.9297V14.9322H28.1097V12.377Z' fill='white' />
      <path d='M28.1097 16.7983H26.9297V19.3535H28.1097V16.7983Z' fill='white' />
      <path d='M28.1097 21.1704H26.9297V23.7256H28.1097V21.1704Z' fill='white' />
    </svg>
  );
};
